import { CONSTANTS } from "../../../constants";

/** Human-readable inspection names aligned with lot summary score cards. */
export const BUILD_QUALITY_STEP_DESCRIPTIONS: Readonly<Record<number, string>> = {
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ1]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ1,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ2]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ2,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ3]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ3,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ4]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ4,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ5]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ5,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ6]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ6,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ7]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ7,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ8]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ8,
  [CONSTANTS.BUILD_QUALITY_STEPS.BQ9]: CONSTANTS.BUILD_QUALITY_STEP_TITLES.BQ9
};

export const DAILY_ITEM_BQ_STEP = 0;
export const DAILY_ITEM_LABEL = "Daily Item";
export const DAILY_ITEM_SUBTITLE = "Not tied to a specific BQ step";

export function getBqStepDisplay(buildQualityStep: number): string {
  if (buildQualityStep === DAILY_ITEM_BQ_STEP) {
    return DAILY_ITEM_LABEL;
  }
  return `BQ${buildQualityStep}`;
}

export function formatBqStepOptionSubtitle(buildQualityStep: number): string {
  if (buildQualityStep === DAILY_ITEM_BQ_STEP) {
    return DAILY_ITEM_SUBTITLE;
  }
  return BUILD_QUALITY_STEP_DESCRIPTIONS[buildQualityStep] ?? "";
}

export function getBqStepLockToastDescription(buildQualityStep: number): string {
  return BUILD_QUALITY_STEP_DESCRIPTIONS[buildQualityStep] ?? `BQ${buildQualityStep}`;
}
